import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    const newPath = lng === 'en' ? '/' : '/ja';
    navigate(newPath);
  };

  return (
    <div className="language-switcher ms-auto">
      <button
        onClick={() => changeLanguage('en')}
        className={location.pathname === '/' ? 'active' : ''}
        aria-label="Switch to English"
      >
        EN
      </button>
      <button
        onClick={() => changeLanguage('ja')}
        className={location.pathname === '/ja' ? 'active' : ''}
        aria-label="Switch to Japanese"
      >
        日本語
      </button>
    </div>
  );
}

export default LanguageSwitcher;